<template>
  <van-form ref="teamForm" input-align="right" error-message-align="right">
    <div
      v-if="!hideTitle"
      class="title"
      :class="{ 'title-with-right': showReselectButton && !readonly }"
    >
      <span>{{ titleDisplay }}</span>
      <span v-if="showReselectButton && !readonly" class="reselect-btn" @click="$emit('reselect')">重选球队</span>
    </div>
    <div v-if="showSelectedTeamInfo" class="selected-team-info">
      <div class="logo">
        <img v-if="team.badge" :src="imageView(team.badge)" alt="">
        <img v-else src="@/assets/default-icon.png" alt="">
      </div>
      <div class="info">
        <div class="name">{{ team.name || '-' }}</div>
        <div class="contact">{{ team.contactPerson || '-' }}</div>
        <div class="phone">{{ team.contactNumber || '-' }}</div>
      </div>
      <div class="right" v-if="!readonly">
        <div class="reselect" @click.stop="$emit('reselect')">重选球队</div>
      </div>
    </div>
    <van-field v-if="teamCheckboxes.name && !isHiddenField('name')" label="队伍名称" v-model="team.name" placeholder="请输入队伍名称"
      :readonly="readonly" :rules="readonly ? [] : [{ required: true, message: '队伍名称不能为空' }]"></van-field>
    <van-field v-if="teamCheckboxes.delegation" label="代表团" v-model="team.delegation" placeholder="请选择代表团"
      :readonly="true" :rules="readonly ? [] : [{ required: true, message: '请选择代表团' }]" :clickable="!readonly" @click="!readonly && $emit('open-delegation')">
    </van-field>
    <van-field v-if="teamCheckboxes.teamAlias" label="队伍简称" v-model="team.teamAlias" placeholder="请输入队伍简称"
      :readonly="readonly" :rules="readonly ? [] : [{ required: true, message: '队伍简称不能为空' }, { validator: regexTeamName, message: '队伍简称最多为12个字符' }]"></van-field>
    <van-field
      v-if="teamCheckboxes.englishName"
      :label="getLabel('englishName')"
      v-model="team.englishName"
      :placeholder="`请输入${getLabel('englishName')}`"
      :readonly="readonly"
      :rules="readonly ? [] : [{ required: true, message: `请输入${getLabel('englishName')}` }]"
    ></van-field>
    <van-field v-if="teamCheckboxes.manager" label="主教练" v-model="team.manager" placeholder="请输入主教练姓名"
      :readonly="readonly" :rules="readonly ? [] : [{ required: true, message: '主教练不能为空' }]"></van-field>
    <van-field
      v-if="teamCheckboxes.contactPerson && !isHiddenField('contactPerson')"
      :label="getLabel('contactPerson')"
      v-model="team.contactPerson"
      :placeholder="`请输入${getLabel('contactPerson')}`"
      :readonly="readonly"
      :rules="readonly ? [] : [{ required: true, message: `${getLabel('contactPerson')}不能为空` }, { validator: regexName, message: `${getLabel('contactPerson')}只能为汉字或字母` }]"
    ></van-field>
    <van-field
      v-if="teamCheckboxes.contactNumber && !isHiddenField('contactNumber')"
      :label="getLabel('contactNumber')"
      v-model="team.contactNumber"
      :placeholder="`请输入${getLabel('contactNumber')}`"
      :readonly="readonly"
      :rules="readonly ? [] : [{ required: true, message: `${getLabel('contactNumber')}不能为空` }, { validator: checkMobile, message: '请输入正确的手机号' }]"
    >
    </van-field>
    <div class="my-field" v-if="teamCheckboxes.badge && !isHiddenField('badge')">
      <van-uploader v-if="!readonly" max-count="1" :preview-image="false" :after-read="onAfterReadBadge" @delete="$emit('delete-badge')">
        <div class="class-logo">
          <div class="img">
            <img src="@/assets/default-icon.png" v-if="!team.badge" />
            <img :src="imageView(team.badge)" v-else />
          </div>
          <div class="logo-info">
            <div class="title2">队徽</div>
            <div class="desc">请上传队徽，建议图片比例1:1</div>
          </div>
          <van-icon name="arrow" class="icon" />
        </div>
      </van-uploader>
      <div v-else class="class-logo class-logo-readonly">
        <div class="img">
          <img src="@/assets/default-icon.png" v-if="!team.badge" />
          <img :src="imageView(team.badge)" v-else />
        </div>
        <div class="logo-info">
          <div class="title2">队徽</div>
        </div>
      </div>
    </div>
    <van-field
      v-if="teamCheckboxes.homeField"
      :label="getLabel('homeField')"
      v-model="team.homeField"
      :placeholder="`请输入${getLabel('homeField')}`"
      :readonly="readonly"
      :rules="readonly ? [] : [{ required: true, message: `请输入${getLabel('homeField')}` }]"
    ></van-field>
    <van-field v-if="teamCheckboxes.summary" label="队伍介绍" v-model="team.summary" placeholder="请输入队伍介绍"
      :readonly="readonly" :rules="readonly ? [] : [{ required: true, message: '队伍介绍不能为空' }]"></van-field>
    <van-field
      v-if="teamCheckboxes.photo"
      :label="getLabel('photo')"
      v-model="team.photo"
      :placeholder="`请输入${getLabel('photo')}`"
      :readonly="readonly"
      :rules="readonly ? [] : [{ required: true, message: `请输入${getLabel('photo')}` }]"
    ></van-field>
    <van-field
      v-if="teamCheckboxes.homePage"
      :label="getLabel('homePage')"
      v-model="team.homePage"
      :placeholder="`请输入${getLabel('homePage')}`"
      :readonly="readonly"
      :rules="readonly ? [] : [{ required: true, message: `请输入${getLabel('homePage')}` }]"
    ></van-field>
    <van-field v-if="teamCheckboxes.homeColor" label="主队颜色" v-model="team.homeClothesColor" placeholder="请选择主队颜色"
      readonly :rules="readonly ? [] : [{ required: true, message: '主队颜色不能为空' }]" :clickable="!readonly" @click="!readonly && $emit('open-home-color')">
      <template #input>
        <div v-if="team.homeClothesColor">
          <img :src="team.homeClothesColorImg" style="width: 24px; height: 24px;" alt="">
        </div>
      </template>
    </van-field>
    <van-field v-if="teamCheckboxes.awayColor" label="客队颜色" v-model="team.awayClothesColor" placeholder="请输入客队颜色"
      readonly :rules="readonly ? [] : [{ required: true, message: '客队颜色不能为空' }]" :clickable="!readonly" @click="!readonly && $emit('open-away-color')">
      <template #input>
        <div v-if="team.awayClothesColor">
          <img :src="team.awayClothesColorImg" style="width: 24px; height: 24px;" alt="">
        </div>
      </template>
    </van-field>
    <van-field v-if="teamCheckboxes.clothesId" label="球衣款式" v-model="team.clothesId" placeholder="请选择球衣款式"
      readonly :rules="readonly ? [] : [{ required: true, message: '球衣款式不能为空' }]" :clickable="!readonly" @click="!readonly && $emit('preview-clothes', team.clothesId)">
      <template #input>
        <div v-if="team.clothesId">
          <van-image :src="imageView(getClothesImg(team.clothesId))" style="width: 24px; height: 24px;"
            alt=""></van-image>
        </div>
      </template>
    </van-field>
    <div class="clotheses" v-if="teamCheckboxes.clothesId" :class="{ 'is-readonly': readonly }">
      <div class="clothes" :class="team.clothesId == item.id ? 'selected' : ''" v-for="(item, index) in clothes"
        :key="'clothes' + index" @click="!readonly && $emit('choose-clothes', item)">
        <img class="img" :src="imageView(item.image)" alt="">
        <div class="disabled" v-if="item.isChoosed === 1">
          <img class="lock" src="@/assets/entry-list/lock.png" alt="">
        </div>
      </div>
    </div>
    <div v-if="teamCheckboxes.clothesColorDescription" style="padding: 0 18px;">
      <p style="font-size: 14px;margin: 12px 0 0 0;">主队队服颜色：</p>
      <van-field v-model="teamColor.home.a" label="上衣" placeholder="请输入上衣颜色"
        :readonly="readonly" :rules="readonly ? [] : [{ required: true, message: '上衣颜色不能为空' }]"></van-field>
      <van-field v-model="teamColor.home.b" label="短裤" placeholder="请输入短裤颜色"
        :readonly="readonly" :rules="readonly ? [] : [{ required: true, message: '短裤颜色不能为空' }]"></van-field>
      <van-field v-model="teamColor.home.c" label="球袜" placeholder="请输入球袜颜色"
        :readonly="readonly" :rules="readonly ? [] : [{ required: true, message: '球袜颜色不能为空' }]"></van-field>
      <van-field v-model="teamColor.home.d" label-width="100px" label="守门员上衣" placeholder="请输入守门员上衣颜色"
        :readonly="readonly" :rules="readonly ? [] : [{ required: true, message: '守门员上衣颜色不能为空' }]"></van-field>
      <van-field v-model="teamColor.home.e" label-width="100px" label="守门员短裤" placeholder="请输入守门员短裤颜色"
        :readonly="readonly" :rules="readonly ? [] : [{ required: true, message: '守门员短裤颜色不能为空' }]"></van-field>
      <van-field v-model="teamColor.home.f" label-width="100px" label="守门员球袜" placeholder="请输入守门员球袜颜色"
        :readonly="readonly" :rules="readonly ? [] : [{ required: true, message: '守门员球袜颜色不能为空' }]"></van-field>
      <van-field v-model="teamColor.home.g" label-width="100px" label="替补背心" placeholder="请输入替补背心颜色"
        :readonly="readonly" :rules="readonly ? [] : [{ required: true, message: '替补背心颜色不能为空' }]"></van-field>
      <p style="font-size: 14px;margin: 12px 0 0 0;">客队队服颜色：</p>
      <van-field v-model="teamColor.away.a" label="上衣" placeholder="请输入上衣颜色"
        :readonly="readonly" :rules="readonly ? [] : [{ required: true, message: '上衣颜色不能为空' }]"></van-field>
      <van-field v-model="teamColor.away.b" label="短裤" placeholder="请输入短裤颜色"
        :readonly="readonly" :rules="readonly ? [] : [{ required: true, message: '短裤颜色不能为空' }]"></van-field>
      <van-field v-model="teamColor.away.c" label="球袜" placeholder="请输入球袜颜色"
        :readonly="readonly" :rules="readonly ? [] : [{ required: true, message: '球袜颜色不能为空' }]"></van-field>
      <van-field v-model="teamColor.away.d" label-width="100px" label="守门员上衣" placeholder="请输入守门员上衣颜色"
        :readonly="readonly" :rules="readonly ? [] : [{ required: true, message: '守门员上衣颜色不能为空' }]"></van-field>
      <van-field v-model="teamColor.away.e" label-width="100px" label="守门员短裤" placeholder="请输入守门员短裤颜色"
        :readonly="readonly" :rules="readonly ? [] : [{ required: true, message: '守门员短裤颜色不能为空' }]"></van-field>
      <van-field v-model="teamColor.away.f" label-width="100px" label="守门员球袜" placeholder="请输入守门员球袜颜色"
        :readonly="readonly" :rules="readonly ? [] : [{ required: true, message: '守门员球袜颜色不能为空' }]"></van-field>
      <van-field v-model="teamColor.away.g" label-width="100px" label="替补背心" placeholder="请输入替补背心颜色"
        :readonly="readonly" :rules="readonly ? [] : [{ required: true, message: '替补背心颜色不能为空' }]"></van-field>
    </div>
    <van-field v-if="teamCheckboxes.insurancePolicy" :label="getLabel('insurancePolicy')" placeholder="请上传参赛资料">
      <template #input>
        <div v-if="readonly && (!team.insurancePolicyList || !team.insurancePolicyList.length)" class="readonly-empty">-</div>
        <div v-else-if="readonly" style="text-align: right;">
          <a v-if="team.insurancePolicy" :href="imageView(team.insurancePolicy)" target="_blank" class="file-link">查看文件</a>
        </div>
        <div v-else style="text-align: right;">
          <van-uploader accept=".pdf,.zip,.rar,.doc,.docx,.xls,.xlsx,.png,.jpg,.bmp" v-model="team.insurancePolicyList" max-count="1" :after-read="onAfterReadFile"
            @delete="$emit('delete-file')">
            <div class="flex-center"
              style="width: 80px;height: 80px;background-color: #F6F7F9;    justify-content: center;">
              <img src="https://images.snsports.cn/FknqQ0fg-ftJt2PItoVb7GXeMAyj" />
            </div>
          </van-uploader>
        </div>
      </template>
    </van-field>
  </van-form>
</template>

<script>
import { Form, Field, Uploader, Image as VanImage } from 'vant'
import Vue from 'vue'
import { QNImageUtil, RegExpr } from '@/utils'

Vue.use(Form).use(Field).use(Uploader).use(VanImage)

export default {
  name: 'EntryInfoTeamForm',
  props: {
    team: { type: Object, required: true },
    teamCheckboxes: { type: Object, default: () => ({}) },
    clothes: { type: Array, default: () => [] },
    teamColor: { type: Object, required: true },
    teamSignupFieldsLabel: { type: Object, default: () => ({}) },
    teamId: { type: String, default: '' },
    /** 标题文案，不传则用默认「队伍信息」/「队伍资料编辑」 */
    titleText: { type: String, default: '' },
    /** 是否在标题右侧显示「重选球队」 */
    showReselectButton: { type: Boolean, default: false },
    /** 隐藏指定字段（如：name/contactPerson/contactNumber/badge） */
    hiddenFields: { type: Array, default: () => [] },
    /** 标题下方展示注册球队信息（logo+名称+联系人+电话+重选球队） */
    showSelectedTeamInfo: { type: Boolean, default: false },
    /** 只读展示（详情页用） */
    readonly: { type: Boolean, default: false },
    /** 是否隐藏顶部标题（用于详情页自定义标题） */
    hideTitle: { type: Boolean, default: false }
  },
  computed: {
    mergedTeamSignupFieldsLabel() {
      return {
        insurancePolicy: '参赛资料',
        homeField: '主场',
        photo: '全家福',
        englishName: '英文名',
        homePage: '主页',
        contactPerson: '联系人',
        contactNumber: '联系电话',
        ...(this.teamSignupFieldsLabel || {})
      }
    },
    titleDisplay() {
      return this.titleText || (this.teamId ? '队伍资料编辑' : '队伍信息')
    }
  },
  methods: {
    getLabel(key) {
      return (this.mergedTeamSignupFieldsLabel && this.mergedTeamSignupFieldsLabel[key]) || key
    },
    isHiddenField(key) {
      return Array.isArray(this.hiddenFields) && this.hiddenFields.includes(key)
    },
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    getClothesImg(id) {
      const c = (this.clothes || []).find(item => item.id === id)
      return c ? c.image : ''
    },
    regexTeamName(value) {
      return this.strLength(value) <= 12
    },
    regexName(value) {
      return /^[A-Za-z\u4e00-\u9fa5\s]+$/.test(value)
    },
    strLength(word) {
      let length = 0
      if (typeof word === 'number') {
        length = word.toString().length
      } else if (word == null) {
        length = word === null ? 3 : 0
      } else {
        Array.from(String(word)).forEach(char => {
          length += char.charCodeAt(0) > 255 ? 2 : 1
        })
      }
      return length
    },
    checkMobile(value) {
      return RegExpr.checkMobile(value)
    },
    onAfterReadBadge(file) {
      this.$emit('upload-badge', file)
    },
    onAfterReadFile(file) {
      this.$emit('upload-file', file)
    },
    validate() {
      return this.$refs.teamForm && this.$refs.teamForm.validate()
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  color: #909399;
  padding-left: 16px;
  &.title-with-right {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 16px;
  }
  .reselect-btn {
    font-size: 14px;
    color: #337ECC;
  }
}
.selected-team-info {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  background-color: var(--bg1, #FFFFFF);
  margin-bottom: 12px;
  .logo {
    width: 60px;
    height: 60px;
    border-radius: 5px;
    background: #D8D8D8;
    overflow: hidden;
    img { width: 100%; height: 100%; object-fit: cover; }
  }
  .info {
    flex: 1;
    margin-left: 16px;
    .name {
      font-size: 16px;
      font-weight: 500;
      color: var(--font-color1, #333);
    }
    .contact, .phone {
      font-size: 12px;
      color: var(--font-color2, #666);
      margin-top: 5px;
    }
  }
  .right {
    display: flex;
    align-items: center;
    .reselect {
      font-size: 14px;
      color: #337ECC;
      line-height: 20px;
    }
  }
}
.my-field {
  padding: 10px 16px;
  background-color: #fff;
}
.class-logo {
  display: flex;
  align-items: center;
  width: 100%;
  // &.class-logo-readonly .logo-info .desc {
  //   display: none;
  // }
  .img {
    width: 60px;
    height: 60px;
    border-radius: 4px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .logo-info {
    flex: 1;
    margin-left: 12px;
    .title2 {
      font-size: 14px;
      color: #333;
    }
    .desc {
      font-size: 12px;
      color: #999;
      margin-top: 4px;
    }
  }
  .icon {
    color: #c8c9cc;
  }
}
.clotheses {
  display: flex;
  flex-wrap: wrap;
  padding: 0 16px 12px;
  &.is-readonly .clothes {
    pointer-events: none;
  }
  .clothes {
    width: 80px;
    margin-right: 12px;
    margin-bottom: 12px;
    position: relative;
    &.selected {
      outline: 2px solid #509dea;
    }
    .img {
      width: 80px;
      height: 80px;
      border-radius: 4px;
      object-fit: cover;
    }
    .disabled {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,.3);
      display: flex;
      align-items: center;
      justify-content: center;
      .lock {
        width: 24px;
        height: 24px;
      }
    }
  }
}
.flex-center {
  display: flex;
  align-items: center;
}
.readonly-empty {
  color: #969799;
  font-size: 14px;
}
.file-link {
  font-size: 14px;
  color: #4AA2F7;
}
/v-deep/ .van-uploader__input-wrapper{
  width: 100%;
}
</style>
